import Tiny from "../components/SetupTiny.js";
import GrandMasterPlan from "../components/SetupGMP.js";
import setupWelcomeTime from "../components/SetupWelcomeTime.js";

export default {
  init() {
    Tiny();
    GrandMasterPlan();
    setupWelcomeTime();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js